import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const TypeScript = () => {
  return (
    <StartInterviewLayout type="typescript"/>
  )
}

export default TypeScript;